exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media print {\n.print-dialog[data-v-3dd6a351] {\n    display: none;\n}\n}", ""]);

// exports
